import { useSearchParams } from '@suntex.core/nav';
import { isAuthenticated, useAuth } from '@suntex.fim/auth/react';
import { usePlayerContext } from '@suntex.fim/player';

import { playerDashboardPath } from './utils/paths';

export function usePlayerDashboardPath(): string {
  const { login } = useAuth(isAuthenticated);
  const { isPreview } = usePlayerContext();
  const [searchParams] = useSearchParams();

  return playerDashboardPath(
    login.entityLevel,
    login.entityId,
    isPreview,
    searchParams.get('from'),
  );
}
